export const SET_VISIBLE_TOOLTIPS = "SET_VISIBLE_TOOLTIPS";

// Only DOM-derived state lives here. The tooltip definitions themselves are server state and
// come from TanStack Query (see components/onboarding-tooltip/onboarding-tooltip-query.ts).
export interface OnboardingTooltipState {
  visibleTooltips: Map<string, HTMLElement>;
}

interface ISetVisibleTooltipsParams {
  visibleTooltips: Map<string, HTMLElement>;
}

interface ISetVisibleTooltipsMeta {
  params: ISetVisibleTooltipsParams;
}

interface SetVisibleTooltipsAction {
  type: typeof SET_VISIBLE_TOOLTIPS;
  meta: ISetVisibleTooltipsMeta;
}

export type OnboardingTooltipActionTypes = SetVisibleTooltipsAction;
